import React from 'react';
import { connect } from 'react-redux';

class SourcesPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      thingSpeak: props.thingSpeak
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      thingSpeak: nextProps.thingSpeak
    });
  }
  render() {
    let thingSpeakSources = (Array.from(this.state.thingSpeak.sources)).map(([key, value]) => value);
    return <div>
      Sources Page
      {
        ((thingSpeakSources)&&(thingSpeakSources.length > 0))?
          (<div>
              {
                thingSpeakSources.map(source => source.displayList())
              }
            </div>):(<div>
              Not Found
            </div>)
      }
    </div>;
  }
}

function mapStateToProps(state, ownProps) {
  return ({
    thingSpeak: state.thingSpeak
  });
}

export default connect (mapStateToProps)(SourcesPage);



// WEBPACK FOOTER //
// ./src/components/admin/SourcesPage.js